import React, {useEffect, useState} from "react";
import logo from '../../images/logo.png'
import { getTelecastsDetail } from "../../service";
import {useParams} from "react-router-dom";
import { TelecastsDetailData } from "../types";
import {Link} from "react-router-dom";
import {useLoading} from "../../components/loading/LoadingProvider";
import {newsTime} from "../../units";

function TelecastDetail(){

    const [info,setInfo] = useState<TelecastsDetailData>()
    const [cover,setCover] = useState<boolean>(false)
    const { showLoading,hideLoading,showError } = useLoading()

    const { id } = useParams<{ id:string }>()

    useEffect(() => {
        showLoading()
        getTelecastsDetail({
            telecastId:id
        }).then(res => {
            hideLoading()
            if(res.code === 1){
                setInfo(res.data)
            }else{
                showError(res.msg)
            }
        })
    },[id])

    return <div className="tele-detail">
        <div className="date">{ newsTime(info) }</div>
        <h3>
            { info?.telecastTitle }
        </h3>
        <p className="owner">
            <img src={ logo } alt=""/>
            <span>荷兰国际管家学院</span>
        </p>
        <div className="detail">
            <div dangerouslySetInnerHTML={{ __html:info ? info.telecastContent : '' }}/>
        </div>

        <div className="fixed-space" style={{height: '1rem'}}>
            <div className="common-fixed">
                <div className="common-btn" onClick={() => setCover(true)}>
                    <p>微信扫码 添加小助手，邀您看直播</p>
                </div>
            </div>
        </div>

        {
            cover && <div className="_cover" onClick={() => setCover(false)}>
                <div className="box" onClick={ event => event.stopPropagation() }>
                    <div className="qrcode" style={{ backgroundImage:`url(${ info?.wechat })` }}/>
                    <p>微信扫码添加小程序，邀您看直播</p>
                </div>
            </div>
        }

    </div>
}

export default TelecastDetail
